import type { Supplier } from './types'

/* Live supplier registry. Populated by ProcurementProvider from the GraphQL API
   (vendors + derived product coverage). Pages look suppliers up synchronously via
   these helpers, while the reactive copy is exposed through useProcurement().suppliers. */
export let suppliers: Supplier[] = []

export function setSuppliers(next: Supplier[]): void {
  suppliers = next
}

export const supplierById = (id: string) => suppliers.find((s) => s.id === id)
export const supplierForProduct = (productId: string) =>
  suppliers.find((s) => s.productIds.includes(productId))
